import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Ata de Fechamento Anual',
    path: '/academico/relatorios/ata',
    name: 'ata-resultados-finais',
    component: () => import('@/views/academico/relatorios/ata/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.ATADEFECHAMENTOANUALNOVO_MENU_300802706],
    },
    goesToMenu: true,
  },
  {
    description: 'Ata de Conselho de Classe',
    path: '/academico/relatorios/ataconselhoclasse',
    name: 'ata-conselho-classe',
    component: () => import('@/views/academico/relatorios/ataconselhoclasse/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.ATADECONSELHODECLASSENOVO_MENU_300802707],
    },
    goesToMenu: true,
  },
];
